<script setup lang="ts">
import Modal from '@/components/display/Modal.vue'
import { useConfirmState } from '@/composables/useConfirm'

const pending = useConfirmState()

function onConfirm() {
  const p = pending.value
  pending.value = null
  p?.resolve(true)
}

function onCancel() {
  const p = pending.value
  pending.value = null
  p?.resolve(false)
}
</script>

<template>
  <Modal
    :show="!!pending"
    :title="pending?.options.title || 'Confirm'"
    size="small"
    @close="onCancel"
  >
    <p class="confirm-message">{{ pending?.message }}</p>
    <template #footer>
      <button class="btn btn-secondary" @click="onCancel">
        {{ pending?.options.cancelLabel || 'Cancel' }}
      </button>
      <button
        :class="['btn', pending?.options.variant === 'primary' ? 'btn-primary' : 'btn-danger']"
        @click="onConfirm"
      >
        {{ pending?.options.confirmLabel || 'Confirm' }}
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.confirm-message {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  line-height: 1.5;
}
</style>
